// ---------------------------------------------------------------------------
// Login Page — Google OAuth entry point
// ---------------------------------------------------------------------------

export function LoginPage() {
  const handleGoogleLogin = () => {
    // Redirect to API OAuth endpoint
    window.location.href = '/api/auth/google';
  };

  return (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Card */}
        <div className="rounded-2xl border border-border bg-surface p-8 shadow-lg">
          {/* Agency branding placeholder */}
          <div className="mb-8 text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-navy text-white font-heading font-bold text-2xl shadow-md">
              SP
            </div>
            <h1 className="font-heading text-2xl font-bold text-navy">Sign in to SubmitPro</h1>
            <p className="mt-2 text-sm text-text-secondary">
              Access your submission pipeline and intake tools
            </p>
          </div>

          {/* Divider */}
          <div className="mb-6 border-t border-border" />

          {/* Google OAuth button */}
          <button
            type="button"
            onClick={handleGoogleLogin}
            className="focus-ring flex w-full items-center justify-center gap-3 rounded-xl border border-border bg-surface px-4 py-3.5 text-sm font-medium text-text-primary shadow-sm transition-all hover:bg-surface-sunken hover:shadow-md active:scale-[0.98]"
          >
            {/* Google icon */}
            <svg
              aria-hidden="true"
              className="h-5 w-5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
            </svg>
            Continue with Google
          </button>

          {/* Footer note */}
          <p className="mt-6 text-center text-xs text-text-muted">
            By signing in, you agree to our Terms of Service and Privacy Policy.
          </p>
        </div>

        {/* Agency branding placeholder */}
        <div className="mt-6 text-center">
          <p className="text-xs text-text-muted">
            Powered by <span className="font-semibold text-navy">SubmitPro</span>
          </p>
        </div>
      </div>
    </div>
  );
}
